"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentPurposeType = void 0;
var PaymentPurposeType;
(function (PaymentPurposeType) {
    PaymentPurposeType["PREMIUM_PAYMENT"] = "Premium Payment";
    PaymentPurposeType["PAYMENT"] = "Payment";
    PaymentPurposeType["POLICY_CHANGE"] = "Policy Change";
    PaymentPurposeType["ADJUSTMENT"] = "Adjustment";
    PaymentPurposeType["SERVICE_CHARGE"] = "Service Charge";
    PaymentPurposeType["NOTIFICATION"] = "Notification";
    PaymentPurposeType["REFUND"] = "Refund";
    PaymentPurposeType["OTHER"] = "Other";
})(PaymentPurposeType = exports.PaymentPurposeType || (exports.PaymentPurposeType = {}));
